import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import React, { useState, useRef, useCallback } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function UploadProfileImage({
  onClose,
  setDefaultImage,
  defaultImage,
  empUserId,
}) {
  const userId = localStorage.getItem("userId");
  const [preview, setPreview] = useState(defaultImage || null);
  const [openCrop, setOpenCrop] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ aspect: 1 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [selectedFile, setSelectedFile] = useState(null);

  const imgRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log("fileis", file);
    if (file) {
      setSelectedFile(file);
      const imageUrl = URL.createObjectURL(file);
      setImageSrc(imageUrl);
      setOpenCrop(true); // Open crop dialog
    }
  };

  const handleRotate = () => {
    setRotation((prev) => (prev + 90) % 360);
  };

  const getCroppedImg = () => {
    const image = imgRef.current;
    if (!image || !completedCrop?.width || !completedCrop?.height) {
     showSnackbar("Image not ready or crop not set properly.", 'error');
      return;
    }

    const canvas = document.createElement("canvas");

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const cropX = completedCrop.x;
    const cropY = completedCrop.y;
    const cropWidth = completedCrop.width;
    const cropHeight = completedCrop.height;

    const radians = rotation * (Math.PI / 180);

    canvas.width = cropWidth;
    canvas.height = cropHeight;

    const ctx = canvas.getContext("2d");

    if (!ctx) return;

    // Center canvas and rotate
    ctx.translate(cropWidth / 2, cropHeight / 2);
    ctx.rotate(radians);
    ctx.translate(-cropWidth / 2, -cropHeight / 2);

    // ⛑ Ensure image is HTMLImageElement
    if (!(image instanceof HTMLImageElement)) {
      console.error("imgRef is not an image");
      return;
    }

    ctx.drawImage(
      image,
      cropX * scaleX,
      cropY * scaleY,
      cropWidth * scaleX,
      cropHeight * scaleY,
      0,
      0,
      cropWidth,
      cropHeight
    );

    canvas.toBlob((blob) => {
      if (blob) {
        const previewUrl = URL.createObjectURL(blob);

        setPreview(previewUrl);
        setOpenCrop(false); // Close crop dialog
      }
    }, "image/jpeg");
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleRemoveImage = () => {
    setPreview(null);
    setImageSrc(null);
    setCompletedCrop(null);
    setSelectedFile(null);
    imgRef.current = null;
  };

  const handleAddUpload = async () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("user_id", userId);

    try {
      const response = await fetch(`${API_ENDPOINT}employee/upload-profile`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.status === 201) {
        showSnackbar(result.message, "success");

        const prevState =
          JSON.parse(localStorage.getItem("employeeState")) || {};

        prevState.employeedetails.image = result?.image;

        // Step 3: Store updated data back to localStorage
        localStorage.setItem("employeeState", JSON.stringify(prevState));

        // Optional: force state update or reload to reflect UI
        console.log("prevState", prevState);
        setTimeout(() => {
          window.location.reload(); // or use router reload / refetch
        }, 1000);
      } else if (response.status === 400) {
        showSnackbar(result.message || "Upload valid image", "error");
      } else {
        showSnackbar("Not able to upload profile. Please try again!", "error");
      }
    } catch (error) {
      showSnackbar("Not able to upload profile. Please try again!", "error");
    }
  };

  const removeProfileImage = async () => {
    const formData = new FormData();
    // formData.append("file", null);
    formData.append("user_id", userId);

    try {
      const response = await fetch(`${API_ENDPOINT}employee/remove-profile`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.status === 201) {
        showSnackbar(result.message, "success");
        setPreview(null);
        setImageSrc(null);
        setCompletedCrop(null);
        setSelectedFile(null);
        imgRef.current = null;

        const prevState =
          JSON.parse(localStorage.getItem("employeeState")) || {};

        prevState.employeedetails.image = null;

        // Step 3: Store updated data back to localStorage
        localStorage.setItem("employeeState", JSON.stringify(prevState));

        // Optional: force state update or reload to reflect UI
        console.log("prevState", prevState);
        setTimeout(() => {
          window.location.reload(); // or use router reload / refetch
        }, 1000);
      } else if (response.status === 400) {
        showSnackbar(result.message || "Upload valid image", "error");
      } else {
        showSnackbar("Not able to upload profile. Please try again!", "error");
      }
    } catch (error) {
      showSnackbar("Not able to remove profile. Please try again!", "error");
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} textAlign="center">
          <Box position="relative" display="inline-block">
            <Avatar
              alt="Profile"
              src={preview}
              sx={{
                width: 120,
                height: 120,
                background: "#dcdcdc",
                color: "white",
              }}
            />
            {parseInt(userId) === empUserId && (
              <IconButton
                component="label"
                size="small"
                style={{
                  position: "absolute",
                  bottom: 0,
                  right: 0,
                  backgroundColor: "#2F7C5F",
                  borderRadius: "50%",
                  padding: 2,
                  boxShadow: 1,
                  border: "2px solid white",
                }}
              >
                <AddCircleIcon style={{ color: "white", fontSize: "1.1rem" }} />
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </IconButton>
            )}
          </Box>
        </Grid>

        {/* <Grid item>
    <Button
      onClick={handleRemoveImage}
      variant="outlined"
      color="error"
      sx={{ borderRadius: "50px", px: 3 }}
    >
      Remove Profile Picture
    </Button>
  </Grid> */}
        <Grid
          item
          xs={12}
          container
          gap={2}
          justifyContent="center"
          alignItems="center"
        >
          <Button
            color="error"
            onClick={removeProfileImage}
            variant="contained"
            style={{ borderRadius: "50px" }}
            disabled={!preview}
          >
            Remove profile picture
          </Button>
          <Button
            variant="contained"
            style={{ background: "#2F7C5F", borderRadius: "50px" }}
            // disabled={!preview}

            onClick={handleAddUpload}
          >
            Save as profile picture
          </Button>
        </Grid>
      </Grid>

      {/* 🌟 Crop + Rotate Dialog */}
      <Dialog
        open={openCrop}
        onClose={() => setOpenCrop(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle textAlign="center" variant="h3">
          Crop & Rotate
        </DialogTitle>
        <Divider />
        <DialogContent
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {imageSrc && (
            <ReactCrop
              crop={crop}
              onChange={(c) => setCrop(c)}
              onComplete={(c) => setCompletedCrop(c)}
              aspect={1}
            >
              <img
                src={imageSrc}
                ref={imgRef}
                alt="To crop"
                onLoad={(e) => {
                  imgRef.current = e.currentTarget; // ✅ Set the actual image DOM
                }}
                style={{
                  transform: `rotate(${rotation}deg)`,
                  maxHeight: 400,
                }}
              />
            </ReactCrop>
          )}
          <IconButton onClick={handleRotate}>
            <RotateLeftIcon style={{ color: "black" }} fontSize="large" />
          </IconButton>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCrop(false)}>Cancel</Button>
          <Button
            onClick={getCroppedImg}
            variant="contained"
            style={{ background: "#2F7C5F" }}
          >
            Apply
          </Button>
        </DialogActions>
        <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
      </Dialog>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
